import React, { useEffect } from "react";
import { useFormik, FormikProvider, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as bie from "react-bootstrap";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import Swal from "sweetalert2";
import { failureAlert } from "../CommonUtils/SweetAlerts.jsx";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import allowNumbersOnly from "../CommonUtils/CommonValidations.js";

export default function ProjectOutcome() {
    const current = new Date();
    const month = current.getMonth() + 1;
    const year = current.getFullYear();


    const validationSchema = Yup.object({


        // ✅ Classroom
        q2_classroom: Yup.string().when("q2", {
            is: (val) => val?.includes("q2_classroom"),
            then: (schema) => schema.required("Enter classroom "),
            otherwise: (schema) => schema.notRequired(),
        }),

        // ✅ Labs
        q2_labs: Yup.string().when("q2", {
            is: (val) => val?.includes("q2_labs"),
            then: (schema) => schema.required("Enter labs "),
            otherwise: (schema) => schema.notRequired(),
        }),

        // ✅ Library
        q2_library: Yup.string().when("q2", {
            is: (val) => val?.includes("q2_library"),
            then: (schema) => schema.required("Enter library details"),
            otherwise: (schema) => schema.notRequired(),
        }),

        // ✅ Toilets
        q2_toilets: Yup.string().when("q2", {
            is: (val) => val?.includes("q2_toilets"),
            then: (schema) => schema.required("Enter toilets details"),
            otherwise: (schema) => schema.notRequired(),
        }),

        // ✅ ICT
        q2_ict: Yup.string().when("q2", {
            is: (val) => val?.includes("q2_ict"),
            then: (schema) => schema.required("Enter ICT details"),
            otherwise: (schema) => schema.notRequired(),
        }),

        // ✅ Sports
        q2_sports: Yup.string().when("q2", {
            is: (val) => val?.includes("q2_sports"),
            then: (schema) => schema.required("Enter sports details"),
            otherwise: (schema) => schema.notRequired(),
        }),

        // ✅ Hostel
        q2_hostel: Yup.string().when("q2", {
            is: (val) => val?.includes("q2_hostel"),
            then: (schema) => schema.required("Enter hostel details"),
            otherwise: (schema) => schema.notRequired(),
        }),

        // ✅ Others
        q2_others_name: Yup.string().when("q2", {
            is: (val) => val?.includes("others"),
            then: (schema) => schema.required("Enter others name"),
            otherwise: (schema) => schema.notRequired(),
        }),

        q2_others_details: Yup.string().when("q2", {
            is: (val) => val?.includes("others"),
            then: (schema) => schema.required("Enter others details"),
            otherwise: (schema) => schema.notRequired(),
        }),
        //
        q1: Yup.string().required(ERROR_MSG).nullable(),
        q1_general: Yup.string().required(ERROR_MSG).nullable(),
        q1_sc: Yup.string().required(ERROR_MSG).nullable(),
        q1_st: Yup.string().required(ERROR_MSG).nullable(),
        q1_bc: Yup.string().required(ERROR_MSG).nullable(),

        q2: Yup.array()
            .min(1, "Select at least one facility")
            .required("Required")
            .nullable(),

        q3: Yup.string().required(ERROR_MSG).nullable(),

        q4: Yup.string().required(ERROR_MSG).nullable(),
        q5: Yup.string().required(ERROR_MSG).nullable(),
        q6: Yup.string().required(ERROR_MSG).nullable(),
        q7: Yup.string().required(ERROR_MSG).nullable(),

        // ✅ Conditional validation
        q7_newrecognition: Yup.string().when("q7", {
            is: (val) => val === "Yes",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),

        q8: Yup.string().required(ERROR_MSG).nullable(),
        q9: Yup.string().required(ERROR_MSG).nullable(),
        q10: Yup.string().required(ERROR_MSG).nullable(),
        q11: Yup.string().required(ERROR_MSG).nullable(),


        q6_after: Yup.string().required(ERROR_MSG).nullable(),
        q4_increased: Yup.string().when("q4", {
            is: (val) => val === "Increased",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        q3_yes: Yup.string().when("q4", {
            is: (val) => val === "Yes",
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
    });

    const RusaFormik = useFormik({
        initialValues: {
            q1: "",
            q1_general: "",
            q1_sc: "",
            q1_st: "",
            q1_bc: "",
            q2: [],
            q2_classroom: "",
            q2_labs: "",
            q2_library: "",
            q2_toilets: "",
            q2_ict: "",
            q2_sports: "",
            q2_hostel: "",
            q2_others_name: "",
            q2_others_details: "",
            q3: "",
            q3_yes: "",
            q4: "",
            q4_increased: "",
            q5: "",
            q6: "",
            q6_after: "",
            q7: "",
            q7_newrecognition: "",
            q8: "",
            q9: "",
            q10: "",
            q11: "",
        },
        validationSchema,
        onSubmit: (val) => {
            val.q1 = parseInt(val.q1 || "", 10);
            val.month = month;
            val.year = year;

            console.log("Submitted values:", val);

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `saveRusaQuestaniores`
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire(res?.data?.sdesc, '', 'success').then((res) => {
                                GetQUestionnaries();
                                // if (res?.isConfirmed) {
                                //     window.location.reload()
                                // }
                            })
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            });
        }
    })

    const selectOptions = (
        <>
            <option value="">--Select--</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
        </>
    );
    function GetQUestionnaries() {
        const url = `${config.url.API_URL}getOverallQuestonariesList?month=${month}&year=${year}`;
        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === "01") {
                const apiData = res.data.data[0];

                RusaFormik.setValues({
                    q1: apiData.q1 ?? "",
                    q1_general: apiData?.q1_general ?? "",
                    q1_sc: apiData.q1_sc ?? "",
                    q1_st: apiData.q1_st ?? "",
                    q1_bc: apiData.q1_bc ?? "",

                    q2: apiData?.q2 ? apiData?.q2.split(",").map(v => v.trim()) : [],
                    q2_classroom: apiData.q2_classroom ?? "",
                    q2_labs: apiData.q2_labs ?? "",
                    q2_library: apiData.q2_library ?? "",
                    q2_toilets: apiData.q2_toilets ?? "",
                    q2_ict: apiData.q2_ict ?? "",
                    q2_sports: apiData.q2_sports ?? "",
                    q2_hostel: apiData.q2_hostel ?? "",
                    q2_others_name: apiData.q2_others_name ?? "",
                    q2_others_details: apiData.q2_others_details ?? "",
                    q2_facilities: apiData.q2_facilities ?? "",
                    q3: apiData.q3 ?? "",
                    q4: apiData.q4 ?? "",
                    q5: apiData.q5 ?? "",
                    q6: apiData.q6 ?? "",
                    q7: apiData.q7 ?? "",
                    q7_newrecognition: apiData.q7_newrecognition ?? "",
                    q8: apiData.q8 ?? "",
                    q9: apiData.q9 ?? "",
                    q10: apiData.q10 ?? "",
                    q11: apiData.q11 ?? "",
                });


            }
            else {

            }
        });
    }

    const calculateQ1Total = (changedField, changedValue) => {
        const values = {
            ...RusaFormik.values,
            [changedField]: changedValue
        };

        const general = Number(values.q1_general) || 0;
        const sc = Number(values.q1_sc) || 0;
        const st = Number(values.q1_st) || 0;
        const bc = Number(values.q1_bc) || 0;

        const total = general + sc + st + bc;

        RusaFormik.setFieldValue("q1", total);
    };

    useEffect(() => {
        GetQUestionnaries();
    }, [])


    return (
        <>
            <bie.Container fluid className="px-0">
                <bie.Container className="px-0 pt-3 mw-100 pb-5">

                    <div className="overal-stathead">
                        <span>  Outcome of the Project</span></div>
                    <FormikProvider value={RusaFormik}>
                        <Form onSubmit={RusaFormik?.handleSubmit} onChange={RusaFormik?.handleChange}>
                            <bie.Row className="align-items-center mb-3">
                                <bie.Col md={3}>
                                    <label className="fw-bold">
                                        1. Approx. Number of Students Benefitted
                                    </label>
                                </bie.Col>
                                {/* GENERAL */}
                                <bie.Col md={1}>
                                    <label className="small">General</label>
                                    <Field
                                        type="text"
                                        name="q1_general"
                                        className="form-control"
                                        maxLength="5"
                                        onKeyPress={allowNumbersOnly}
                                        onChange={(e) => {
                                            RusaFormik.handleChange(e);
                                            calculateQ1Total("q1_general", e.target.value);
                                        }}
                                    />

                                    <ErrorMessage name="q1_general" component="div" className="text-danger" />

                                </bie.Col>

                                {/* SC */}
                                <bie.Col md={1}>
                                    <label className="small">SC</label>
                                    <Field
                                        type="text"
                                        name="q1_sc"
                                        className="form-control"
                                        maxLength="5"
                                        onKeyPress={allowNumbersOnly}

                                        onChange={(e) => {
                                            RusaFormik.handleChange(e);
                                            calculateQ1Total("q1_sc", e.target.value);
                                        }}
                                    />
                                    <div className="text-danger">
                                        <ErrorMessage name="q1_sc" />
                                    </div>
                                </bie.Col>

                                {/* ST */}
                                <bie.Col md={1}>
                                    <label className="small">ST</label>
                                    <Field
                                        type="text"
                                        name="q1_st"
                                        className="form-control"
                                        maxLength="5"
                                        onKeyPress={allowNumbersOnly}

                                        onChange={(e) => {
                                            RusaFormik.handleChange(e);
                                            calculateQ1Total("q1_st", e.target.value);
                                        }}
                                    />
                                    <div className="text-danger">
                                        <ErrorMessage name="q1_st" />
                                    </div>
                                </bie.Col>

                                {/* BC */}
                                <bie.Col md={1}>
                                    <label className="small">BC</label>
                                    <Field
                                        type="text"
                                        name="q1_bc"
                                        className="form-control"
                                        maxLength="5"
                                        onKeyPress={allowNumbersOnly}

                                        onChange={(e) => {
                                            RusaFormik.handleChange(e);
                                            calculateQ1Total("q1_bc", e.target.value);
                                        }}
                                    />
                                    <div className="text-danger">
                                        <ErrorMessage name="q1_bc" />
                                    </div>
                                </bie.Col>
                                <bie.Col md={2}>
                                    <label className="small">Total</label>
                                    <Field
                                        type="text"
                                        name="q1"
                                        className="form-control"
                                        readOnly
                                    />

                                    <ErrorMessage name="q1" component="div" className="text-danger" />

                                </bie.Col>

                            </bie.Row>
                            <bie.Row className="align-items-center mb-3 pt-5">
                                <bie.Col md={3}>
                                    <label className="fw-bold">2. Facilities improved for students</label>
                                </bie.Col>
                                <bie.Col md={9}>
                                    <div className="d-flex flex-wrap gap-3">
                                        {[
                                            { label: "Classrooms", field: "q2_classroom" },
                                            { label: "Labs", field: "q2_labs" },
                                            { label: "Library", field: "q2_library" },
                                            { label: "Toilets", field: "q2_toilets" },
                                            { label: "ICT", field: "q2_ict" },
                                            { label: "Sports", field: "q2_sports" },
                                            { label: "Hostel", field: "q2_hostel" },
                                            { label: "Others", field: "others" }
                                        ].map(({ label, field }) => (
                                            <div key={label} className="d-flex flex-column gap-2">
                                                <label className="d-flex align-items-center gap-1">
                                                    <Field type="checkbox" name="q2" value={field} onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        RusaFormik?.handleChange(e);
                                                        if (!checked) {
                                                            if (field === "others") {
                                                                RusaFormik?.setFieldValue("q2_others_name", "");
                                                                RusaFormik?.setFieldValue("q2_others_details", "");
                                                            } else {
                                                                RusaFormik?.setFieldValue(field, "");
                                                            }
                                                        }
                                                    }} />
                                                    {label}
                                                </label>

                                                {/* Show textbox if selected */}
                                                {RusaFormik?.values?.q2?.includes(field) && (
                                                    <>
                                                        {field === "others" ? (
                                                            <>
                                                                <Field
                                                                    type="text"
                                                                    name="q2_others_name"
                                                                    className="form-control"
                                                                    maxLength={150}
                                                                    style={{ width: "120px" }}
                                                                />
                                                                <ErrorMessage name="q2_others_name" component="div" className="text-danger" />

                                                                <Field
                                                                    type="text"
                                                                    name="q2_others_details"
                                                                    className="form-control mt-2"
                                                                    maxLength={50}
                                                                    style={{ width: "120px" }}
                                                                />
                                                                <ErrorMessage name="q2_others_details" component="div" className="text-danger" />
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Field
                                                                    type="text"
                                                                    name={field}
                                                                    className="form-control"
                                                                    maxLength={5}
                                                                    onKeyPress={allowNumbersOnly}

                                                                    style={{ width: "120px" }}
                                                                />
                                                                <ErrorMessage name={field} component="div" className="text-danger" />
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    <div className="text-danger">
                                        <ErrorMessage name="q2" />
                                    </div>
                                </bie.Col>
                            </bie.Row>



                            <bie.Row className="align-items-center mb-3 pt-3">
                                <bie.Col md={8}>
                                    <label className="fw-bold">
                                        3. Any new academic programmes or skill courses introduced due to improved infrastructure?
                                    </label>
                                </bie.Col>
                                <bie.Col md={2}>

                                    <Field as="select" name="q3" className="form-control" onChange={(e) => RusaFormik.setFieldValue("q3_yes", '')}>
                                        {selectOptions}
                                    </Field>
                                    <div className="text-danger"><ErrorMessage name="q3" /></div>
                                </bie.Col>
                                {RusaFormik?.values?.q3 === "Yes" && (
                                    <bie.Col md={2}>
                                        <Field as="textarea" name="q3_yes" className="form-control"></Field>
                                        <div className="text-danger"><ErrorMessage name="q3_yes" /></div>
                                    </bie.Col>
                                )}
                            </bie.Row>

                            <bie.Row className="align-items-center mb-3">
                                <bie.Col md={8}>
                                    <label className="fw-bold">
                                        4. Has student attendance or enrolment increased after RUSA interventions?
                                    </label>
                                </bie.Col>
                                <bie.Col md={2}>
                                    <Field as="select" name="q4" className="form-control"
                                        onChange={(e) => RusaFormik.setFieldValue("q4_increased", '')}>
                                        <option value=''>---select--</option>
                                        <option value="Increased">Increased  </option>
                                        <option value="so_significant_change">No significant change</option>
                                        <option value="Decreased">Decreased </option>
                                    </Field>
                                    <div className="text-danger"><ErrorMessage name="q4" /></div>
                                </bie.Col>
                                {RusaFormik?.values?.q4 === "Increased" && (
                                    <bie.Col md={2}>
                                        <Field as="textarea" name="q4_increased" className="form-control"></Field>
                                        <div className="text-danger"><ErrorMessage name="q4_increased" /></div>
                                    </bie.Col>
                                )}
                            </bie.Row>

                            <bie.Row className="align-items-center mb-3">
                                <bie.Col md={8}>
                                    <label className="fw-bold">
                                        5. Briefly describe improvements in academic activities.
                                    </label>
                                </bie.Col>
                                <bie.Col md={2}>
                                    <Field as="textarea" name="q5" className="form-control" maxLength={150}>
                                    </Field>
                                    <div className="text-danger"><ErrorMessage name="q5" /></div>
                                </bie.Col>
                            </bie.Row>

                            <bie.Row className="align-items-center mb-3">
                                <bie.Col md={8}>
                                    <label className="fw-bold">
                                        6. NAAC Accreditation Status (Before and After RUSA support)
                                    </label>
                                </bie.Col>

                                {/* Before */}
                                <bie.Col md={2}>
                                    <label className="mb-1">Before</label>
                                    <Field
                                        type="text"
                                        name="q6"
                                        className="form-control"
                                        placeholder="Enter Before Details"
                                        maxLength={5}
                                    />
                                    <div className="text-danger">
                                        <ErrorMessage name="q6" />
                                    </div>
                                </bie.Col>

                                {/* After */}
                                <bie.Col md={2}>
                                    <label className="mb-1">After</label>
                                    <Field
                                        type="text"
                                        name="q6_after"
                                        className="form-control"
                                        placeholder="Enter After Details"
                                        maxLength={5}

                                    />
                                    <div className="text-danger">
                                        <ErrorMessage name="q6_after" />
                                    </div>
                                </bie.Col>
                            </bie.Row>


                            <bie.Row className="align-items-center mb-3">
                                <bie.Col md={8}>
                                    <label className="fw-bold">
                                        7. Has the institution received new recognition, ranking, or awards post-RUSA?
                                    </label>
                                </bie.Col>
                                <bie.Col md={2}>
                                    <Field as="select" name="q7" className="form-control" onChange={(e) => RusaFormik.setFieldValue("q7_newrecognition", '')}
                                    >
                                        {selectOptions}
                                    </Field>
                                    <div className="text-danger"><ErrorMessage name="q7" /></div>
                                </bie.Col>
                                {RusaFormik?.values?.q7 === "Yes" && (
                                    <bie.Col md={2}>
                                        <Field as="textarea" name="q7_newrecognition" className="form-control" maxLength={150}></Field>
                                        <div className="text-danger"><ErrorMessage name="q7_newrecognition" /></div>
                                    </bie.Col>
                                )}

                            </bie.Row>

                            <bie.Row className="align-items-center mb-3">
                                <bie.Col md={8}>
                                    <label className="fw-bold">
                                        8. Facilities benefitting girl students / differently-abled students
                                    </label>
                                </bie.Col>
                                <bie.Col md={2}>
                                    <Field as="textarea" name="q8" className="form-control" maxLength={150}>
                                        {selectOptions}
                                    </Field>
                                    <div className="text-danger"><ErrorMessage name="q8" /></div>
                                </bie.Col>

                            </bie.Row>

                            <bie.Row className="align-items-center mb-3">
                                <bie.Col md={8}>
                                    <label className="fw-bold">
                                        9. Major challenges faced in implementation
                                    </label>
                                </bie.Col>
                                <bie.Col md={2}>
                                    <Field as="textarea" name="q9" className="form-control" maxLength={150}>
                                    </Field>
                                    <div className="text-danger"><ErrorMessage name="q9" /></div>
                                </bie.Col>
                            </bie.Row>

                            <bie.Row className="align-items-center mb-3">
                                <bie.Col md={8}>
                                    <label className="fw-bold">
                                        10. Improvement in energy efficiency or sustainability practices
                                        (solar panels, green campus, etc.)
                                    </label>
                                </bie.Col>
                                <bie.Col md={2}>
                                    <Field as="textarea" name="q10" className="form-control" maxLength={150}>
                                    </Field>
                                    <div className="text-danger"><ErrorMessage name="q10" /></div>
                                </bie.Col>
                            </bie.Row>

                            <bie.Row className="align-items-center mb-3">
                                <bie.Col md={8}>
                                    <label className="fw-bold">
                                        11.	Suggestions for further improvement
                                    </label>
                                </bie.Col>
                                <bie.Col md={2}>
                                    <Field as="textarea" name="q11" className="form-control" maxLength={150}>
                                    </Field>
                                    <ErrorMessage name="q11" component="div" className="text-danger" />

                                </bie.Col>
                            </bie.Row>

                            <bie.Row className="mt-3">
                                <bie.Col className="text-end">
                                    <bie.Button type="submit" variant="success" onClick={() => focusFirstError(RusaFormik.errors)}>
                                        Submit
                                    </bie.Button>
                                </bie.Col>
                            </bie.Row>


                        </Form>
                    </FormikProvider>
                </bie.Container>
            </bie.Container>
        </>
    );
}


